import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=eac3cd96"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"
import style0 from "./Language.vue?vue&type=style&index=0&id=eac3cd96&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LanguageList: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Language/LanguageList.vue').default})
